import React, {useEffect, useState, useContext} from 'react';
import {UserContext} from "@providers/user";
import {PropertiesDispatcherContext} from "@providers/properties";
import {FilterContext} from "@providers/filters";
import {getBookmarkedPropertiesIds, handlePropertyFollow} from "@models/property";
import PropertiesSkeleton from "../property/skeleton";
import {pluckKeyToArray} from "../../hooks/selection.options";
import {isEmpty} from "@helpers/helpers";
import SearchPropertyListCards from "./search_cards/lists_card";
import SearchGridCards from "./search_cards/grid_card";
import {checkUserModality} from "../property/helpers/property_helpers";
import {getSearchHotLinks} from "../property/helpers/search_helper";

var hotLinksFlag = true;
const SearchPropertyCard = ({properties, urlParams, isBadeSaba, windowSize, gridView = false, skeleton, categories, ssrHotLinks, handleGetProperties, setContactInfo, setForceShowNoResult, setSkeleton, setLogin}) => {
    const userContext = React.useContext(UserContext);
    const properties_dispatcher = useContext(PropertiesDispatcherContext);
    const filters = useContext(FilterContext);

    // states
    const [bookmarkedProperties, setBookmarkedProperties] = useState([]);
    const [hotLinks, setHotLinks] = useState([]);

    // custom variables
    const selectedFiltersDistrictIds = !isEmpty(urlParams['district_id']) ? urlParams['district_id'] : pluckKeyToArray(filters.selected_filters.district_id, 'value');
    const hotLinksLists = (!isEmpty(hotLinks) && hotLinks.length) ? hotLinks : ((!isEmpty(ssrHotLinks) && ssrHotLinks.length) ? ssrHotLinks : []);
    // useEffect

    useEffect(() => {
        if (userContext.check && bookmarkedProperties.length < 1) {
            getBookmarkedPropertiesIds(userContext.user.id).then(result => {
                setBookmarkedProperties(result.properties);
            }).catch(err => {
                console.log(err)
            });
        }
    }, [userContext]);

    useEffect(() => {
        if (process.browser && hotLinksFlag) {
            const {city, deal_type, district, types} = filters.waiting;

            if (!city && !deal_type && !district && !types) {
                hotLinksFlag = false;

                getSearchHotLinks(filters.selected_filters, selectedFiltersDistrictIds, isBadeSaba).then(result => {
                    setHotLinks(result);
                    hotLinksFlag = true;
                })
            }
        }
    }, [filters]);

    // functions
    const bookmarkProperty = (property_id, follow = true) => {
        if (!isEmpty(property_id)) {

            const followBox = document.querySelector('.follow-box-' + property_id);

            if (!isEmpty(followBox)) {
                if (follow) {
                    followBox.classList.add('followed');
                } else {
                    followBox.classList.remove('followed');
                }
            }

            handlePropertyFollow(property_id, follow).then(result => {
                getBookmarkedPropertiesIds(userContext.user.id).then(result => {
                    setBookmarkedProperties(result.properties);
                }).catch(err => {
                    console.log(err)
                });
            }).catch(err => {
                console.log(err)
            });
        }
    };

    const handleBookmark = (property_id, follow = true, userContext) => {
        if (userContext.check) {
            bookmarkProperty(property_id, follow);
        } else {
            function callbackRunBookmark(callback) {
                callback(arguments[1], arguments[2]);
            }

            setLogin({show: true, callback: () => callbackRunBookmark(bookmarkProperty, property_id, follow)})
        }
    };

    const handleShowProperty = (e, link, media = 0) => {
        e.preventDefault();
        e.stopPropagation();

        properties_dispatcher({
            type: 'PUSH_STATE',
            payload: {
                link: link,
                href: '/properties/show',
                media: (media > 5) ? 5 : media,
                loading: true,
                offsetTop: window.pageYOffset + 1,
                back: false,
                isBadeSaba: isBadeSaba
            }
        })
    };

    const modalityData = {
        city_id: filters.selected_filters.city_id,
        district_id: filters.selected_filters.district_id,
        deal_type: filters.selected_filters.deal_type
    };

    const checkShowInvestBanner = checkUserModality(modalityData);

    if (skeleton) {
        return (
            <div className="mb-56">
                <PropertiesSkeleton
                    repeat={(gridView ? 8 : 4)}
                    gridView={gridView}
                    windowSize={windowSize}
                    className="mx-24 mx-md-0"
                />
            </div>
        );
    } else if (properties && properties.length) {
        if (gridView) {
            return (
                <SearchGridCards
                    properties={properties}
                    isBadeSaba={isBadeSaba}
                    selected_filters={filters.selected_filters}
                    handleBookmark={handleBookmark}
                    bookmarkedProperties={bookmarkedProperties}
                    hotLinksItems={hotLinksLists}
                    categories={categories}
                    selectedFiltersDistrictIds={selectedFiltersDistrictIds}
                    userContext={userContext}
                    handleShowProperty={handleShowProperty}
                    handleGetProperties={handleGetProperties}
                    windowSize={windowSize}
                    setForceShowNoResult={setForceShowNoResult}
                    setContactInfo={setContactInfo}
                    checkShowInvestBanner={checkShowInvestBanner}
                />
            )
        } else {
            return (
                <SearchPropertyListCards
                    properties={properties}
                    isBadeSaba={isBadeSaba}
                    filters={filters}
                    handleBookmark={handleBookmark}
                    bookmarkedProperties={bookmarkedProperties}
                    hotLinks={hotLinksLists}
                    categories={categories}
                    selectedFiltersDistrictIds={selectedFiltersDistrictIds}
                    userContext={userContext}
                    handleShowProperty={handleShowProperty}
                    handleGetProperties={handleGetProperties}
                    windowSize={windowSize}
                    setForceShowNoResult={setForceShowNoResult}
                    setContactInfo={setContactInfo}
                    checkShowInvestBanner={checkShowInvestBanner}
                />
            )
        }
    } else {
        return ''
    }
};

function propsAreEqual(prevProps, nextProps) {
    return (
        (prevProps.properties.length === nextProps.properties.length) &&
        (prevProps.skeleton === nextProps.skeleton) &&
        (prevProps.authCheck === nextProps.authCheck) &&
        (prevProps.windowSize === nextProps.windowSize)
    );
}

export default React.memo(SearchPropertyCard, propsAreEqual);
